<template>
  <b-modal
    id="time-adding-child-info-modal"
    ref="time-adding-child-info-modal"
    body-class="p-10"
    centered
    title="Time to add your first child"
    content-class="p-2"
    no-close-on-backdrop
    hide-header
    hide-footer
    @hidden="resetModal"
    @show="openModal"
  >
    <div>
      <h2 class="info-modal-title">Time to add your first child</h2>

      <div class="info-modal-buttons w-100 d-flex">
        <b-button
          class="border border-primary"
          variant="outline-primary"
          @click="skipForNow"
        >
          Skip For Now
        </b-button>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="addNewChild"
        >
          Add
        </b-button>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex">
        <b-button
          class="border border-primary"
          variant="outline-primary"
          @click="skipForNow"
        >
          Skip For Now
        </b-button>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="addNewChild"
        >
          Add
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
export default {
  components: {
    BModal,
    BButton,
  },
  methods: {
    resetModal() {},
    openModal() {},
    addNewChild() {
      this.$bvModal.hide('time-adding-child-info-modal')
      this.$emit('add-new-child')
    },
    skipForNow() {
      this.$bvModal.hide('time-adding-child-info-modal')
      this.$emit('skip')
    },
  },
}
</script>

<style lang="scss" scoped>
  .info-modal-title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }

  .info-modal-buttons {
    padding: 0 30px;
  }
</style>